import { render, staticRenderFns } from "./sliderUpdate.vue?vue&type=template&id=0a821eac&scoped=true&"
import script from "./sliderUpdate.vue?vue&type=script&lang=js&"
export * from "./sliderUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a821eac",
  null
  
)

export default component.exports